<template>
  <div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/">
      <icon name="dashboard" class="mr-2 w-4 h-4"
        :class="isUrl('') ? 'fill-primary-50' : 'fill-white group-hover:fill-primary-50'" />
      <div :class="isUrl('') ? 'text-primary-50' : 'text-white group-hover:text-primary-50'">Dashboard</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/servers">
      <icon name="office" class="mr-2 w-4 h-4"
        :class="isUrl('servers') ? 'fill-primary-50' : 'fill-white group-hover:fill-primary-50'" />
      <div :class="isUrl('servers') ? 'text-primary-50' : 'text-white group-hover:text-primary-50'">Server</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/customers">
      <icon name="users" class="mr-2 w-4 h-4"
        :class="isUrl('customers') ? 'fill-primary-50' : 'fill-white group-hover:fill-primary-50'" />
      <div :class="isUrl('customers') ? 'text-primary-50' : 'text-white group-hover:text-primary-50'">Kunden</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/domains">
      <icon name="domains" class="mr-2 w-4 h-4"
        :class="isUrl('domains') ? 'fill-primary-50' : 'fill-white group-hover:fill-primary-50'" />
      <div :class="isUrl('domains') ? 'text-primary-50' : 'text-white group-hover:text-primary-50'">Domains</div>
      </Link>
    </div>
    <div class="mb-4">
      <Link class="group flex items-center py-3" href="/tools">
      <icon name="tools" class="mr-2 w-4 h-4"
        :class="isUrl('tools') ? 'fill-primary-50' : 'fill-white group-hover:fill-primary-50'" />
      <div :class="isUrl('tools') ? 'text-primary-50' : 'text-white group-hover:text-primary-50'">Tools</div>
      </Link>
    </div>
    <!--     <div class="mb-4">
      <Link class="group flex items-center py-3" href="/reports">
        <icon name="printer" class="mr-2 w-4 h-4" :class="isUrl('reports') ? 'fill-primary-50' : 'fill-white group-hover:fill-primary-50'" />
        <div :class="isUrl('reports') ? 'text-primary-50' : 'text-white group-hover:text-primary-50'">Reports</div>
      </Link>
    </div> -->
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
    Link,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter((url) => currentUrl.startsWith(url)).length
    },
  },
}
</script>
